export const ActiveShippingLocationsColumnId = 'ActiveShippingLocations';
export const AuditColumnId = 'Audit';

export const baseColumnsDefaultConfigs = [
  {
    id: 'Alerts',
    mappedId: 'alerts',
    width: 100,
    pinned: false,
    index: 0,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'SKU',
    mappedId: 'sku',
    width: 100,
    pinned: false,
    index: 1,
    minWidth: 70,
    sorted: 'descending',
  },
  {
    id: 'ProductName',
    mappedId: 'productName',
    width: 100,
    pinned: false,
    index: 2,
    minWidth: 70,
  },
  // TODO: Need to map warehouses to inventory
  {
    id: 'WarehouseName',
    mappedId: 'warehouseName',
    width: 100,
    pinned: false,
    index: 3,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'WarehouseLocation',
    mappedId: 'warehouseLocation',
    width: 100,
    pinned: false,
    index: 4,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: ActiveShippingLocationsColumnId,
    mappedId: 'activeShippingLocations',
    width: 200,
    pinned: false,
    index: 5,
    minWidth: 200,
    nonsortable: true,
  },
  {
    id: 'Stock',
    mappedId: 'stock',
    width: 100,
    pinned: false,
    index: 6,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Allocated',
    mappedId: 'allocated',
    width: 100,
    pinned: false,
    index: 7,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Available',
    mappedId: 'available',
    width: 100,
    pinned: false,
    index: 8,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Active',
    mappedId: 'active',
    width: 100,
    pinned: false,
    index: 9,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'ParentSKU',
    mappedId: 'parentSKU',
    width: 100,
    pinned: false,
    index: 10,
    minWidth: 70,
  },
  {
    id: 'Reorder',
    mappedId: 'reorderThreshold',
    width: 100,
    pinned: false,
    index: 11,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'Tracked',
    mappedId: 'tracked',
    width: 100,
    pinned: false,
    index: 12,
    minWidth: 70,
    nonsortable: true,
  },
  {
    id: 'ProductType',
    mappedId: 'productType',
    width: 100,
    pinned: false,
    index: 13,
    minWidth: 70,
  },
  {
    id: AuditColumnId,
    mappedId: 'audit',
    width: 180,
    pinned: false,
    index: 14,
    minWidth: 140,
    nonsortable: true,
  },
  {
    id: 'Actions',
    mappedId: 'actions',
    width: 100,
    pinned: false,
    index: 15,
    minWidth: 70,
    nonsortable: true,
  },
];
